module.exports = __webpack_public_path__ + "pink1.ec976eb8.png";